import { FC } from 'react';
import { WarrantyGuide } from './WarrantyGuide/WarrantyGuide';

export const WarrantyGuidePage: FC = () => {
  return <WarrantyGuide />;
};
